import React from 'react';
import * as styles from './ordered-list.module.css';

export const OrderedList: React.FC = (props) => (
  <ol
    {...props}
    className={`pb-4 font-body leading-relaxed text-justify pl-5 list-inside ${styles.ol}`}
  />
);
